import { stringifyLogValue } from './stringify-log-value';
import { webLogPost } from './web-log';

export function logError(err: unknown) {
  // eslint-disable-next-line no-console
  console.error(err);

  const message = stringifyLogValue(err);
  const attributes =
    err instanceof Error
      ? {
          name: err.name,
          stack: err.stack,
        }
      : undefined;

  webLogPost({ attributes, level: 'error', message });
}
